/**
 * Created by anthony on 8/11/14.
 */

var bin = angular.module('bin');
bin.classy.controller({
    name: 'BinSummaryController',
    inject: ['$scope', 'BinFactory', 'BinSummaryService', 'BinService', 'SchoolSubcategoriesModelService',
        'SchoolModelService', 'AccountModelService', '$rootScope', '$timeout'],
    init: function()
    {
        this.BinSummaryService.refresh();
        this.$.BinFactory = this.BinFactory;
        this.$.BinSummaryService = this.BinSummaryService; 
        this.$.BinService = this.BinService;
        this.$.isArchive = this.BinFactory.isArchive();
        this.$.allAccounts = this.AccountModelService.get();
        this.$.NewReturnLabel = { 0: 'Uncategorized', 1 : 'New', 2: 'Returning' }
        this.$.GradesLabel = { "00" : 'Pre-School', "01" : 'Pre-Kindergarten', "02": "Kindergarten", "03": "First", "04": "Second", "05": "Third",
            "06": "Fourth", "07": "Fifth", "08": "Sixth", "09": "Seventh", "10": 'Eighth', "11": 'Ninth', "12": "Tenth",
            "13": "Eleventh", "14": "Twelfth", "15": "Post-grad"
        };
        this.$.Accounts = {};
        for (var i = 0; i < this.AccountModelService.get().accounts.length; i++)
        {
            var account = this.AccountModelService.get().accounts[i];
            this.$.Accounts[account.recordID] = {}
            this.$.Accounts[account.recordID].Account = account.Account;
            this.$.Accounts[account.recordID].Budget = account.Budget;
        }

        var parent = this;
        this.$.SubCatsLabel = {};
        this.$.categories = this.SchoolSubcategoriesModelService.get();
        angular.forEach(this.SchoolSubcategoriesModelService.get(), function(value, key) {
            parent.$.SubCatsLabel[value.recordID] = value.subcategory;
        });
        this.$.SchoolModelService = this.SchoolModelService;
        this.$.hasGradeFilter = false; 
        this.$.hasTaxFilter = false;
        
    },
    differential: function()
    {
        if (!this.filterFilter(this.BinService.filter['accountsFilter']).length)
            return this.SchoolModelService.get()[0].Total_Award_Budget - this.BinSummaryService.calculateTotalAwarded();
        else if (this.$.Accounts[this.filterFilter(this.BinService.filter['accountsFilter'])[0]])
            return this.$.Accounts[this.filterFilter(this.BinService.filter['accountsFilter'])[0]].Budget - this.BinSummaryService.calculateTotalAwarded();
        else
            return 0;
    },
    filterFilter: function(values)
    {
        var result = [];
        for(let t in values.values)
        {
            if (values.values[t] == true) {
                result[result.length] = t;
            }
        }
        return result;
    },
    removeFilter: function(filter, key)
    {
        this.BinService.filter[filter].values[key] = false;
        this.BinService.updateFilter(filter);
    },
    hasFilters: function()
    {
        var taxFilter =  this.filterFilter(this.BinService.filter['taxFilter']);
        var NRFilter = this.filterFilter(this.BinService.filter['NRFilter']);
        var SubCatsFilter = this.filterFilter(this.BinService.filter['SubCatsFilter']);
        var gradeFilter = this.filterFilter(this.BinService.filter['gradeFilter']);
        var accountsFilter = this.filterFilter(this.BinService.filter['accountsFilter']);

        this.$.hasGradeFilter = gradeFilter.length > 0 ? 1 : 0;
        this.$.hasTaxFilter = taxFilter.length > 0 ? 1 : 0;

        if (this.BinService.getBin() == 'Award')
            return (taxFilter.length + NRFilter.length + SubCatsFilter.length + gradeFilter.length + accountsFilter.length);
        else
            return (taxFilter.length + NRFilter.length + SubCatsFilter.length + gradeFilter.length);
    },
    updateFilterRadio: function(filter, value)
    {
        var newVal = this.BinService.filter[filter].values[value];
        this.BinService.filter[filter].values = {};
        this.BinService.filter[filter].values[value] = newVal;
        this.BinService.updateFilter(filter);
    },
    stopPropagation:function(event)
    {
        event.stopPropagation();
    }

});
